"use strict";
const { object, string, array } = require('../../utils/modifiedYup');
const { EMAIL_REGEX, PHONE_REGEX } = require('../../utils/regex');
const distributionListRecipientSchema = object().shape({
    type: string().oneOf(['distributionList']).required(),
    iuxId: string().required(),
});
const contactRecipientSchema = object().shape({
    type: string().oneOf(['contact']).required(),
    iuxId: string().required(),
});
const userRecipientSchema = object().shape({
    type: string().oneOf(['user']).required(),
    iuxId: string().required(),
});
const adhocPhoneRecipientSchema = object().shape({
    type: string().oneOf(['adhoc']).required(),
    value: string().matches(PHONE_REGEX, 'Invalid phone recipient').required(),
});
const adhocEmailRecipientSchema = object().shape({
    type: string().oneOf(['adhoc']).required(),
    value: string().matches(EMAIL_REGEX, 'Invalid email recipient').required(),
});
const variableRecipientSchema = object().shape({
    stepId: string().required(),
    type: string().oneOf(['variable']).required(),
    variableId: string().required(),
});
const smsRecipientsSchema = array(object().oneOfSchemas([
    distributionListRecipientSchema,
    contactRecipientSchema,
    userRecipientSchema,
    adhocPhoneRecipientSchema,
    variableRecipientSchema,
])).min(1);
const emailRecipientsSchema = array(object().oneOfSchemas([
    distributionListRecipientSchema,
    contactRecipientSchema,
    userRecipientSchema,
    adhocEmailRecipientSchema,
    variableRecipientSchema,
])).min(1);
module.exports = {
    distributionListRecipientSchema,
    contactRecipientSchema,
    userRecipientSchema,
    adhocPhoneRecipientSchema,
    adhocEmailRecipientSchema,
    variableRecipientSchema,
    smsRecipientsSchema,
    emailRecipientsSchema,
};
//# sourceMappingURL=recipientSchema.js.map